export const FETCH_SOLAR_INTENSITY = 'FETCH_SOLAR_INTENSITY';
export const FETCH_SOLAR_INTENSITY_SUCCESS = 'FETCH_SOLAR_INTENSITY_SUCCESS';
export const FETCH_SOLAR_INTENSITY_FAIL = 'FETCH_SOLAR_INTENSITY_FAIL';
export const FETCH_SOLAR_INTENSITY_FETCHING = 'FETCH_SOLAR_INTENSITY_FETCHING';

export const SET_SOLAR_DATE = 'SET_SOLAR_DATE';
